import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceTeacher } from '../../hooks/useAuthorizedRequestForTeacher';
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from '../../components/GeneratePdf';
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from '../../components/CurrentTime';
import { Loader } from '../../components/ModalsCommonFunctions';

const SectionTeachingPlan = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosTeacher = generateAxiosInstanceTeacher()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const initialFormState = {
        academicYearMasterId: "",
        teacherMasterId: "",
        profileId: "",
        date: "",
        endDate: "",
        instituteGradeMasterId: "",
        instituteDivisionMasterId: "",
        instituteSubjectMasterId: ""
    }

    const [academicYearList, setAcademicYearList] = useState([])
    const [teacherList, setTeacherList] = useState([])
    const [profileList, setProfileList] = useState([])
    const [instituteLogo, setInstituteLogo] = useState([])
    const [teacherData, setTeacherData] = useState(initialFormState)
    const [teachingPlan, setTeachingPlan] = useState([])
    const [editId, setEditId] = useState(null)

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getAcademicYearList();
    }, []);

    const getAcademicYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;

        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setAcademicYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleAcademicYearChange = (e) => {
        const { name, value } = e.target;
        setTeacherData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                teacherMasterId: "",
                profileId: "",
                instituteGradeMasterId: "",
                instituteDivisionMasterId: "",
                instituteSubjectMasterId: ""
            }
        })

        const apiUrl1 = `/academic-year-wise-teacher-data?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&academicYearMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl1)
            .then(response => {
                setTeacherList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        const apiUrl2 = `/get-sections-academic-years?sectionMasterId=${sectionMasterId}&academicYearMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
            .then(response => {
                if (response.data.data.length > 0) {
                    const data = response.data.data[0];
                    setTeacherData((prevData) => {
                        return {
                            ...prevData,
                            date: data?.startDate,
                            endDate: data?.endDate
                        }
                    })
                }
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getProfileList = (matchedItem) => {
        return matchedItem.teacherMappingDetails.map(mappingDetail => {
            const { instituteGradeMasterId, instituteDivisionMasterId, instituteSubjectMasterId } = mappingDetail;
            const { gradeName } = mappingDetail.instituteGradeMasterDetails;
            const { divisionName } = mappingDetail.instituteDivisionMasterDetails;
            const { subjectName } = mappingDetail.instituteSubjectMasterDetails;

            return {
                id: matchedItem.id,
                profileId: `${instituteGradeMasterId}-${instituteDivisionMasterId}-${instituteSubjectMasterId}`,
                instituteGradeMasterId,
                instituteDivisionMasterId,
                instituteSubjectMasterId,
                teacherDetails: `${gradeName}-${divisionName}-${subjectName}`
            };
        });
    }

    const handleTeacherChange = (e) => {
        const { name, value } = e.target;
        setTeacherData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                profileId: "",
                instituteGradeMasterId: "",
                instituteDivisionMasterId: "",
                instituteSubjectMasterId: ""
            }
        })

        const matchedItem = teacherList.find(item => item.id.toString() === value.toString());
        if (!matchedItem) {
            setProfileList([]);
        } else {
            setProfileList(getProfileList(matchedItem))
        }
    }

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const selectedProfile = profileList.find(profile => profile.profileId === value);

        setTeacherData((prevData) => ({
            ...prevData,
            [name]: selectedProfile.profileId,
            instituteGradeMasterId: selectedProfile.instituteGradeMasterId,
            instituteDivisionMasterId: selectedProfile.instituteDivisionMasterId,
            instituteSubjectMasterId: selectedProfile.instituteSubjectMasterId
        }));
    };

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(teacherData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    }

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(teacherData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [teacherData])

    const showResult = () => {
        if (validateForm()) {
            setLoading(true);
            let apiUrl = `/get-daily-teaching?`;
            if (teacherData.teacherMasterId) {
                apiUrl += `teacherId=${teacherData.teacherMasterId}&`;
            }

            if (teacherData.date) {
                apiUrl += `date=${teacherData.date}&`;
            }

            if (teacherData.endDate) {
                apiUrl += `endDate=${teacherData.endDate}&`;
            }

            if (teacherData.instituteGradeMasterId) {
                apiUrl += `instituteGradeMasterId=${teacherData.instituteGradeMasterId}&`;
            }

            if (teacherData.instituteDivisionMasterId) {
                apiUrl += `instituteDivisionMasterId=${teacherData.instituteDivisionMasterId}&`;
            }

            if (teacherData.instituteSubjectMasterId) {
                apiUrl += `subjectId=${teacherData.instituteSubjectMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            authorizedAxiosTeacher && authorizedAxiosTeacher.get(apiUrl)
                .then(response => {
                    setTeachingPlan(response.data.result);
                    setInstituteLogo(response.data.result[0]?.instituteMasterDetails?.logoPath);
                })
                .catch(error => {
                    setTeachingPlan([]);
                    setInstituteLogo(null);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(teacherData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const renderRows = (dailyTeachingList) => {
        return dailyTeachingList.map((item, i) => {
            let syllabusStructureName = "";
            let lessonName = "";
            let topicName = "";
            let subTopicName = "";

            const type = item.type;
            const syllabusStructureId = item.syllabusStructureId ? item.syllabusStructureId : 0;
            const topicId = item.topicId ? item.topicId : 0;
            const subtopicId = item.subTopicId ? item.subTopicId : 0;

            if (type === "A" /*Constants.USER_TYPE_ADMIN*/) {
                if (topicId === 0 && subtopicId === 0) {
                    lessonName = item.lessonName.toString();
                    topicName = "";
                    subTopicName = "";
                } else if (topicId !== 0 && subtopicId === 0) {
                    lessonName = item.subTopicMasterLessonMasterDetails?.lessonName.toString();
                    topicName = item.topicMasterDetails?.topicName;
                    subTopicName = "";
                } else if (topicId !== 0 && subtopicId !== 0) {
                    lessonName = item.subTopicMasterLessonMasterDetails?.lessonName.toString();
                    topicName = item.topicMasterDetails?.topicName;
                    subTopicName = item.subTopicName.toString();
                }
                if (syllabusStructureId !== 0) {
                    syllabusStructureName = item?.syllabusStructureMasterDetails?.syllabusStructureName ? item.syllabusStructureMasterDetails.syllabusStructureName : "";
                }
            } else if (type === "I" /*Constants.USER_TYPE_INSTITUTE*/) {
                if (topicId === 0 && subtopicId === 0) {
                    lessonName = item.lessonName.toString();
                    topicName = "";
                    subTopicName = "";
                } else if (topicId !== 0 && subtopicId === 0) {
                    lessonName = item.instituteLessonMasterDetails?.lessonName.toString();
                    topicName = item.instituteTopicMasterDetails?.topicName;
                    subTopicName = "";
                } else if (topicId !== 0 && subtopicId !== 0) {
                    lessonName = item.instituteLessonMasterDetails?.lessonName.toString();
                    topicName = item.instituteTopicMasterDetails?.topicName;
                    subTopicName = item.instituteSubTopicName.toString();
                }

                if (syllabusStructureId !== 0) {
                    syllabusStructureName = item?.instituteSyllabusStructureMasterDetails?.syllabusStructureName ? item.instituteSyllabusStructureMasterDetails.syllabusStructureName : "";
                }
            } else if (type === "B" /*Constants.USER_TYPE_SECTION*/) {
                if (topicId === 0 && subtopicId === 0) {
                    lessonName = item.lessonName.toString();
                    topicName = "";
                    subTopicName = "";
                } else if (topicId !== 0 && subtopicId === 0) {
                    lessonName = item.sectionLessonMasterDetails?.lessonName.toString();
                    topicName = item.sectionTopicMasterDetails?.topicName;
                    subTopicName = "";
                } else if (topicId !== 0 && subtopicId !== 0) {
                    lessonName = item.sectionLessonMasterDetails?.lessonName.toString();
                    topicName = item.sectionTopicMasterDetails?.topicName;
                    subTopicName = item.sectionSubTopicName.toString();
                }
                if (syllabusStructureId !== 0) {
                    syllabusStructureName = item?.instituteSyllabusStructureMasterDetails?.syllabusStructureName ? item.instituteSyllabusStructureMasterDetails.syllabusStructureName : "";
                }
            }

            return (
                <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{syllabusStructureName}</td>
                    <td>{(item.date).split('T')[0].split('-').reverse().join('-')}</td>
                    <td>{lessonName}</td>
                    <td>{topicName}</td>
                    <td>{subTopicName}</td>
                    <td>{item.noOfLectures}</td>
                </tr>
            );
        });
    };

    const handleInputReset = () => {
        setTeacherData(initialFormState);
        setTeachingPlan([]);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Teaching Plan</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-school"></i>Teaching Plan</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="academicYearMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleAcademicYearChange} value={teacherData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            academicYearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.academicYearMasterId && <p style={{ color: 'red' }}>{error.academicYearMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Teacher :</label>
                                                    <select class="form-select" aria-label="Default select example" disabled={editId} name='teacherMasterId' onChange={handleTeacherChange} value={teacherData.teacherMasterId}>
                                                        <option selected value={''} disabled>Select Teacher</option>
                                                        {
                                                            teacherList?.map((teacher) => {
                                                                return <option value={teacher.id}>{teacher.teacherName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.teacherMasterId && <p style={{ color: 'red' }}>{error.teacherMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="profileId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Profile :</label>
                                                    <select class="form-select" aria-label="Default select example" name='profileId' onChange={handleInputChange} value={teacherData.profileId}>
                                                        <option selected value={''} disabled>Select Profile</option>
                                                        {
                                                            profileList?.map((profile) => {
                                                                return <option value={profile.profileId}>{profile.teacherDetails}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.profileId && <p style={{ color: 'red' }}>{error.profileId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={showResult}>Show</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="separator"></div>
                                                {teachingPlan && teachingPlan.length > 0 && <GeneratePdf id="examReportContent" /*title={`Teaching Plan : ${teachingPlan[0].teacherMasterDetails.teacherName}`}*/ />}
                                                {teachingPlan.length > 0 ?
                                                    <div class="report_block" id='examReportContent'>
                                                        <div class="heading">
                                                            <div class="logo">
                                                                <img src={instituteLogo} alt="" />
                                                            </div>
                                                            <div class="text_center">
                                                                <h6>{teachingPlan[0]?.instituteMasterDetails?.instituteName}</h6>
                                                                <h4>{teachingPlan[0]?.sectionMasterDetails?.sectionName}</h4>
                                                            </div>
                                                            <div class="logo">
                                                                <img src={VidyaUpasna} alt="" />
                                                            </div>
                                                        </div>
                                                        <div class="report_code text_center mb-3">
                                                            <img src={separator_line} alt="" className="line" />
                                                            <span className="txt">Daily Teaching Plan</span>
                                                        </div>

                                                        <div class="report_head">
                                                            <span>Board: {teachingPlan[0]?.sectionMasterDetails?.boardMasterDetails?.boardName}</span>
                                                            <span>Medium: {teachingPlan[0]?.sectionMasterDetails?.streamOrMediumMasterDetails?.streamName}</span>
                                                        </div>

                                                        <div class="candidate_details teacher_details">
                                                            <h4 class="table_caption">Associate Details</h4>
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td width="100%" colspan="2">
                                                                            <h5>Teacher Name : <span>{teachingPlan[0]?.teacherMasterDetails?.teacherName}</span></h5>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="50%">
                                                                            <h5>Class : <span>{teachingPlan[0]?.instituteGradeMasterDetails?.gradeName}</span></h5>
                                                                        </td>
                                                                        <td>
                                                                            <h5>Division : <span>{teachingPlan[0]?.instituteDivisionMasterDetails?.divisionName}</span></h5>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td width="50%">
                                                                            <h5>Subject : <span>{teachingPlan[0]?.type === "A" ? teachingPlan[0]?.subjectMasterDetails?.subjectName : teachingPlan[0]?.instituteSubjectMasterDetails?.subjectName}</span></h5>
                                                                        </td>
                                                                        <td>
                                                                            <h5>Academic Year : <span>{teachingPlan[0]?.sectionMasterDetails?.sectionsAcadamicYearsDetails[0]?.academicYearMasterDetails?.yearName}</span></h5>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div class="analysis_report schedule_table">
                                                            <span class="table_caption">
                                                                Myself {teachingPlan[0]?.teacherMasterDetails?.teacherName}, declares that, I have created my daily teaching plan as shown below:
                                                            </span>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Sr No</th>
                                                                        <th>Syllabus Structure</th>
                                                                        <th>Date</th>
                                                                        <th>Lesson</th>
                                                                        <th>Topic</th>
                                                                        <th>Sub Topic</th>
                                                                        <th>No of Lectures</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        teachingPlan?.length && renderRows(teachingPlan)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div class="report_footer">
                                                            <div>
                                                                <span>{getCurrentTime()}</span>
                                                                <span>Time stamp of export</span>
                                                            </div>
                                                            <div>
                                                                <span>{teachingPlan[0]?.teacherMasterDetails?.teacherName}</span>
                                                                <span>Teacher Name</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="text-center" style={{ padding: "50px", fontWeight: 'bold' }}>
                                                        No Teaching Plan Available
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionTeachingPlan;